import { TFunction } from "i18next";
import { ReferralResponseDto } from "../types/referrals";
import { AppointmentDetailsForReferralDto } from "../types/appointments";

export const getReferralFileName = (
    referral: ReferralResponseDto,
    t: TFunction,
) => {
    const effectiveDateTime = new Date(referral.effectiveDateTime);
    const date = effectiveDateTime.toLocaleDateString();
    const time = effectiveDateTime.toLocaleTimeString();
    return `${t('referral')}_${
        referral.code
    }_${date}_${time}.pdf`;
};

export const mapAppointmentDetailsToReferral = (
    referralDetails: AppointmentDetailsForReferralDto,
) => {
    const {id, patient, medic} = referralDetails;
    const patientOrChild = referralDetails.child || patient;
    return {
        appointmentId: id,
        medicBusinessRole: medic?.businessRole || '',
        medicId: medic?.userId || '',
        medicNPWZ: medic?.npwz || '',
        medicName: medic?.firstName || '',
        medicSurname: medic?.surname || '',
        medicTitle: medic?.title || '',
        medicSpecialties: medic?.specialties || [],
        patientId: patient?.userId || '',
        patientName: patientOrChild?.firstName || '',
        patientPesel: patientOrChild?.pesel || '',
        patientSurname: patientOrChild?.surname || '',
        patientHomeAddress: patient?.homeAddress,
    };
};